<template lang="pug">
    v-card.conversation-card(elevation="0" @click="handleClick")
        v-toolbar.message-header(dense flat)
            div.header-icon-container.mr-3(style="position: relative;")
                v-icon.unread-icon(
                    v-if="hasUnreadMessages"
                ) mdi-circle-medium
                v-icon
                    template(v-if="isGroupChat") mdi-account-group
                    template(v-else) mdi-account
            v-toolbar-title
                span.text-medium(:style="{ fontWeight: hasUnreadMessages ? 'bold' : 'normal' }")
                    | {{ conversationGroup.other_user_names }}
            v-spacer
            .text-right.text-small.last-message-time
                | {{ conversationGroup.friendly_last_message_time }}
                v-icon.ml-1.mb-1(small) mdi-chevron-right

        v-card-text.px-4.pa-0
            v-row.ma-0.ml-9.pa-0.pb-2.text-small.message-body
                | {{ conversationGroup.last_message_body | str_limit(150) || 'Sent an attachment' }}
    </template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
        }
    },
    methods: {
        handleClick() {
            this.$emit('view-conversation');
        },
    },
    computed: {
        isGroupChat() {
            return this.conversationGroup.total_participants > 2;
        },
        hasUnreadMessages() {
            return this.conversationGroup.has_unread_messages;
        },
        hasUnrespondedIncomingMessage() {
            return this.conversationGroup.has_unresponded_incoming_message;
        },
    },
    components: {

    },
    props: {
        conversationGroup: {
            type: Object,
            required: true,
        },
    },
})
</script>

<style lang="scss" scoped>
    .conversation-card {
        border-radius: 0px;
        border-bottom: 1px solid var(--lt-gray);

        .unread-icon {
            position: absolute;
            color: var(--error);
            left: -20px;
            font-size: 28px;

        }

        &.v-card.v-card--link {
            &:focus {
                visibility: hidden !important;
            }
        }

        .incoming-message-icon {
            max-width: fit-content;
            justify-self: flex-end;
        }

        .last-message-time {
            color: var(--volie-gray);
            min-width: fit-content;
        }

        .message-header {
            height: fit-content !important;
        }

        :deep(.v-toolbar__content) {
            height: fit-content !important;
            padding-right: 5px;
        }

        .message-body {
            max-width: 90%;
            word-break: break-word;
        }
    }
</style>